import { IconProps } from '@models/icons';

function ArrowLineRight({ size = 30, color = '#6E6864', ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path d="M18.5 6L24.5 14.5L18.5 23" stroke={color} strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>

  );
}

export default ArrowLineRight;
